import styled from 'styled-components';

export const BannerNotificationContainer = styled.div`
position: relative;
z-index: 3;
width: 100%;
min-height: ${(props) => props.isReviewerBanner ? '40px' : '60px'} ;
height: ${(props) => props.isReviewerBanner ? '40px' : 'auto'} ;
align-self: center;
background: ${(props) => props.type === 'alert' ? 
    props.theme['color.redDark'] : 
    (props.type === 'warning' ? props.theme['color.orangeDark'] : props.isReviewerBanner ? props.theme['color.tealDark'] : props.theme['color.blueDark'])};
border-radius: 0px;
display: flex;  
flex-wrap: wrap;
 `;

export const BannerNotificationIcon = styled.div`
color:${(props) => props.theme['color.white']} ;
margin-top: 16px;
height: 19px;
width: 1.5%;
margin-left: 37px;
 `;

export const BannerNotificationCloseIcon = styled.div`
background:  ${(props) => props.type === 'alert' ? 
    props.theme['color.redDark'] : 
    (props.type === 'warning' ? props.theme['color.orangeDark'] : props.theme['color.blueDark'])};
color:${(props) => props.theme['color.white']} ;
min-height: 40px;
height: auto;
align-self: center;
width: 5%;
cursor: pointer;
font-size: 12px;
font-weight: 700;
`;

export const BannerNotificationWarning = styled.span`
width: 90%;
height: auto;
min-height: 20px;
font-weight:  ${(props) => props.isReviewerBanner ? '500' : '600'} ;
font-size: 14px;
line-height: 19px;
display: flex;
align-items: center;
color: ${(props) => props.theme['color.white']} ;
margin-left: 10px;
`;

export const BannerNotificationMessage = styled.div`
`;